/**
 * Renders a HTML content section loaded from a local file.
 *
 * The `HtmlSection` component fetches an external HTML file (from the app’s
 * public root) and injects its contents into an accordion section.
 * 
 * -- Usually a .html file with the file name in the config.json point to it ("welcomePath": "welcome.html") --
 * 
 */

import React, { useEffect, useState } from "react";
import AccordionSection, { AccordionSectionHandle } from "../../utils/accordion/AccordionSection";
import "./styles/HtmlSection.css";

type Props = {
    title: string;
    file?: string;
    defaultOpen?: boolean;
    sectionRef?: React.RefObject<AccordionSectionHandle | null>;
};

const HtmlSection: React.FC<Props> = ({ title, file, defaultOpen, sectionRef }) => {
    const [html, setHtml] = useState("");

    useEffect(() => {
        if (!file) return;

        fetch(`${process.env.PUBLIC_URL}/${file}`)
            .then(async (r) => {
                if (!r.ok) throw new Error(`HTTP ${r.status}`);
                setHtml(await r.text());
            })
            .catch((err) => {
                console.error("Failed to load HTML section:", err);
                setHtml("");
            });
    }, [file]);

    return (
        <AccordionSection title={title} defaultOpen={defaultOpen} ref={sectionRef}>
            {html ? (
                <div className="html" dangerouslySetInnerHTML={{ __html: html }} />
            ) : (
                <div style={{ color: "crimson" }}>{file} not available.</div>
            )}
        </AccordionSection>
    );
};

export default HtmlSection;
